<template>
  <div class="row">
    <div class="col_12">
      <div class="card border_none">
        <div class="card_body pl_5 pr_5">
          <ticket-table-component
              :columns="columns"
              :rows="records"
              :sortable="sortable"
              :pagination="pagination"
              @sorting="sorting"
              @pageChanged="pageChanged"
          >
            <template v-slot:payment_method="{ row }">
              <div>{{ row?.payment_method?.name }}</div>
            </template>
          </ticket-table-component>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import TicketTableComponent from "@/components/shared/TicketTableComponent.vue";

    export default {
      name: 'InvoicePaymentHistory',
      components: {TicketTableComponent},
      props: ['closeModal', 'invoiceId'],
      data(){
          return {
            lyLoading: false,
            records: [],
            queryParams: {
              page: 1,
              search: '',
              search_columns: 'invoice_number,invoice_date,month_of_invoice,total_amount',
              sort: 'created_at',
              sort_order: 'desc',
              per_page: 10
            },
            sortable: {
              order: 'created_at',
              sort: 'desc'
            },
            columns: [
              {
                label: "Invoice",
                field: "invoice_number",
              },
              {
                label: "Amount",
                field: "total_amount",
                sortable: true,
              },
              {
                label: "Invoice Date",
                field: "formatted_total_amount",
              },
              {
                label: "Payment By",
                field: "payment_collect",
              },
              {
                label: "Payment Method",
                field: "payment_method",
                slot: true
              },
              {
                label: "Status",
                field: "status",
                sortable: true,
              },
              {
                label: "Process At",
                field: "action_at",
                sortable: true,
              },
              {
                label: "Response",
                field: "comment",
              },
            ],
            pagination: null,
          }
      },
      created() {
          this.getCloudService()
      },
      methods: {
        getCloudService(){
            this.lyLoading = true;
            this.axios.get(`/invoice-payment-history/${this.invoiceId}`, {
              params: {...this.queryParams, ...this.filter}
            })
            .then(({ data }) => {
              this.records = data.data;
              this.pagination = data.meta
            })
            .finally(() => {
                this.lyLoading = false;
            })
        },
        searchQuery() {
          // A new search/filter changes the result set, so the old page number
          // no longer means anything — start from the first page.
          this.queryParams.page = 1;
          this.changeRoute();
        },
        sorting({column, order}) {
          this.queryParams.sort = column;
          this.queryParams.sort_order = order;
          this.queryParams.page = 1;
          this.changeRoute()
        },
        pageChanged(page) {
          this.queryParams.page = page;
          this.changeRoute()
        },
        changeRoute() {
          this.$router.push({name: this.$route.name, query: {...this.queryParams, ...this.filter}})
        },
      }
    }
</script>
<style scoped>

</style>
